module.exports = __webpack_public_path__ + "static/sports4-873393470a3452fe4f429d83b2cef324.gif";